

  export function setConfig(assine_environment){
    let firebaseConfig;
    if( assine_environment == "sandbox"){
      return  firebaseConfig = {
        "apiKey": "AIzaSyD-K0KkAF6zVqTG76LKhZZwTjk535hc81Y",
        "authDomain": "abril-id-homolog.firebaseapp.com",
        "projectId": "abril-id-homolog",
        "storageBucket": "abril-id-homolog.appspot.com",
        "messagingSenderId": "22104083922",
        "appId": "1:22104083922:web:cc6fd7f70eaf7af2c94c0b",
        "measurementId": "G-EVWVRPMW5H"
        };
    }

    return  firebaseConfig = {
      "apiKey": "AIzaSyDV6Cih4lwxoWn51Qxvc5OGdxxDt_QDdBE",
      "authDomain": "abril-id-testes-1528223718961.firebaseapp.com",
      "projectId": "abril-id-testes-1528223718961",
      "storageBucket": "abril-id-testes-1528223718961.appspot.com",
      "messagingSenderId": "1087443011751",
      "appId": "1:1087443011751:web:e98ef467de50e048f7b382"
      };

}